// src/components/NotFound.jsx

import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <h1 className="text-6xl md:text-7xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-xl md:text-2xl text-gray-700 mb-8">
        Oops! The page you&#39;re looking for doesn&#39;t exist.
      </p>
      <Link
        to="/"
        className="px-6 py-3 bg-green-600 text-white font-semibold rounded-md hover:bg-green-700 transition"
      >
        Go to Home
      </Link>
    </div>
  );
};

export default NotFound;
